<div>{{ dsoNameService.getName(object) }}</div>
